module.exports = __webpack_public_path__ + "static/images/smoothness/ui-icons_cd0a0a_256x240.png";